<script>
export default {
    name: 'IconEyeHidden',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-eye-hidden"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M48.336 22.909C50.99 25.312 53.544 28.343 56 32c-7.163 10.667-15.163 16-24 16-3.177 0-6.245-.69-9.206-2.068l6.088-5.487a9 9 0 0011.84-10.672zM51.5 16l-5.51 4.967-2.587 2.332-3.844 3.465-.145.132-13.257 11.95-6.164 5.556L16 48h-4l5.74-5.172C14.336 40.212 11.09 36.602 8 32c7.163-10.667 15.163-16 24-16 4.083 0 7.987 1.138 11.712 3.415L47.5 16h4zM32 23a9 9 0 00-7.6 13.823l3.838-3.46a4 4 0 015.506-4.963l3.838-3.46A8.962 8.962 0 0032 23z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
